import { render, staticRenderFns } from "./ListInspectionFormPage.vue?vue&type=template&id=20f912aa"
import script from "./ListInspectionFormPage.vue?vue&type=script&lang=js"
export * from "./ListInspectionFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports